import { MEMBER_MAX_AGE, MEMBER_MIN_AGE } from '@/constants';
import { parse } from 'date-fns';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';

export const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s,.'-]*$/;

export const validateDateOfBirth = (date: string | null, ctx: any) => {
  const invalidDateMessage = () => {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message:
        date === ''
          ? `Date of birth is required`
          : `Please enter a valid date in the format MM/DD/YYYY`,
    });
  };

  if (!date) {
    invalidDateMessage();
    return;
  }

  const dateOfBirth = parse(date, 'MM/dd/yyyy', new Date());
  const currentDate = new Date();

  if (isNaN(dateOfBirth.getTime())) {
    invalidDateMessage();
    return;
  }

  if (dateOfBirth > currentDate) {
    {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Date of birth can't be in the future`,
      });
    }
    return;
  }

  let age = currentDate.getFullYear() - dateOfBirth.getFullYear();
  const monthDifference = currentDate.getMonth() - dateOfBirth.getMonth();
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && currentDate.getDate() < dateOfBirth.getDate())
  ) {
    age--;
  }
  // EC-87: Check if the age is less than 18
  if (age < MEMBER_MIN_AGE) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `You must be at least 18 years old`,
    });
  }
  //EC-173: Check members max age
  if (age > MEMBER_MAX_AGE) {
    invalidDateMessage();
  }

  return true;
};

export const validatePhoneNumber = (phoneNumber: string, ctx: any) => {
  const invalidPhoneNumberMessage = () => {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Phone number is required',
    });
  };

  if (!phoneNumber) {
    invalidPhoneNumberMessage();
    return;
  }

  if (!isPossiblePhoneNumber(phoneNumber)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Invalid phone number',
    });
  }
};

export const validateReferrerInformation = (data: any, ctx: any) => {
  if (data.medicalReferral === 'true') {
    !data.referrerName &&
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Provider's name is required",
        path: ['referrerName'],
      });

    !data.referrerPhoneNumber &&
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Provider's phone number is required",
        path: ['referrerPhoneNumber'],
      });
  }
};
